const referenceId = value => {
    const id = value && typeof value === 'object' ? value._id : value;
    return id ? String(id) : '';
};

// Older calendar responses contain a forecast label in `customer`, not a customer ID.
// Resolve the relationship from the opportunity instead of guessing from that label.
export async function resolveCalendarCustomers(lines, fetchOpportunity) {
    const requests = new Map();
    return Promise.all(lines.map(async line => {
        const populatedCustomer = line.customer && typeof line.customer === 'object' ? line.customer : null;
        const customerId = referenceId(line.customerId) || referenceId(populatedCustomer);
        if (customerId) return { ...line, customerId, customerName: line.customerName || populatedCustomer?.organizationName };

        const opportunityId = referenceId(line.opportunityId);
        if (!opportunityId) return line;
        if (!requests.has(opportunityId)) {
            requests.set(opportunityId, Promise.resolve().then(() => fetchOpportunity(opportunityId)).catch(() => null));
        }
        const opportunity = await requests.get(opportunityId);
        return {
            ...line,
            customerId: referenceId(opportunity?.customer),
            customerName: opportunity?.customer?.organizationName || line.customerName,
        };
    }));
}
